import { gql } from "@apollo/client";

export const createKEKPolicy = gql`
  mutation CreateKEKInputOffer($offerInput: Offer_data!) {
    createInputOffer(offer_input: $offerInput) {
      offer_id
    }
  }
`;

export const updateKEKPolicy = gql`
  mutation UpdateKEKInputOffer(
    $offerInput: Offer_data!
    $offerId: ID!
    $offerDetailId: ID!
  ) {
    updateInputOffer(
      offer_input: $offerInput
      offer_id: $offerId
      offer_detail_id: $offerDetailId
    )
  }
`;

export const clearChequeue = gql`
  mutation ChequeClearance($clearance: ClearanceData) {
    chequeClearance(clearance: $clearance)
  }
`;

export const makeProportionalPayment = gql`
  mutation MakeProportionalPayment($payment: PaymentDetails) {
    makeProportionalPayment(payment: $payment)
  }
`;

export const LOGIN = gql`
  mutation KEKLogin($username: String!, $password: String!) {
    login(input: { username: $username, password: $password }) {
      access_token
      refresh_token
      expires_in
      token_type
      user {
        user_id
        position
        first_time_signin
        employee {
          emp_abbrv
          employee_id
          employee_email
          employee_last_name
          employee_first_name
          employee_phonenumber
          accept_waiver_aggreement
        }
        user_role {
          position
          privileges
        }
      }
    }
  }
`;

export const removeKEKOfferClaim = gql`
  mutation DeleteKEKClaimAmount($offerId: ID!, $offerClaimId: ID!) {
    deleteClaimAmount(offer_id: $offerId, offer_claim_id: $offerClaimId)
  }
`;

export const takeKEKReinsurerClaimPayment = gql`
  mutation CreateKEKOfferClaimPayment(
    $claimPayments: OfferClaimParticipantPaymentInput!
  ) {
    createOfferClaimPayment(claim_payments: $claimPayments)
  }
`;

export const updateKEKOfferClaim = gql`
  mutation UpdateKEKClaimAmount($offerClaimId: ID!, $claimData: Claim_data!) {
    updateClaimAmount(offer_claim_id: $offerClaimId, claim_data: $claimData)
  }
`;

export const sendKEKClaimNotification = gql`
  mutation SendKEKClaimNotification($emailData: Email_data!) {
    sendClaimNotification(email_data: $emailData)
  }
`;

export const createOfferClaim = gql`
  mutation MakeKEKClaim($data: Claim_data!) {
    makeClaimOnOffer(claim_data: $data)
  }
`;

export const generateFinanceFacultativeReport = gql`
  mutation GenerateFinanceFacultativeReport(
    $reportData: FacultativeReportData
  ) {
    generateFinanceFacultativeReport(reportData: $reportData)
  }
`;

export const generateFinanceTreatyReport = gql`
  mutation GenerateFinanceTreatyReport($reportData: TreatyReportData) {
    generateFinanceTreatyReport(reportData: $reportData)
  }
`;

export const placeOffer = gql`
  mutation PlaceOfferAt($offerId: ID!, $placedOffer: Float!) {
    placeOfferAt(offer_id: $offerId, placed_offer: $placedOffer)
  }
`;

export const deleteOfferFromSystem = gql`
  mutation DeleteKEKOfferFromSystem($offerId: ID!, $reason: String) {
    deleteOfferFromSystem(offer_id: $offerId, reason: $reason)
  }
`;

export const renewFacOffer = gql`
  mutation RenewFacOffer($offerId: ID) {
    renewFacOffer(offer_id: $offerId)
  }
`;

export const addPrecentageToParticipant = gql`
  mutation KEKAddPercentage(
    $offer_participant_id: ID!
    $offer_id: ID!
    $percentage: Float!
    $reopen: Boolean
  ) {
    addPrecentageToParticipant(
      offer_participant_id: $offer_participant_id
      offer_id: $offer_id
      participating_percentage: $percentage
      reopen: $reopen
    ) {
      offer_amount
    }
  }
`;

export const createPayment = gql`
  mutation MakeKEKPaymentOnOffer($paymentInfo: Offer_payment_data!) {
    makePaymentOnOffer(payment_info: $paymentInfo)
  }
`;

export const updateKEKEndorsementOffer = gql`
  mutation UpdateKEKEndorsementOffer(
    $offerInput: Offer_data!
    $offerEndorsementDetailId: ID
    $offerEndorsementId: ID
    $offerId: ID
  ) {
    updateEndorsementOffer(
      offer_input: $offerInput
      offer_endorsement_detail_id: $offerEndorsementDetailId
      offer_endorsement_id: $offerEndorsementId
      offer_id: $offerId
    )
  }
`;

export const approveKEKEndorsementOffer = gql`
  mutation ApproveKEKEndorsementOffer(
    $offerId: ID
    $offerEndorsementId: ID
    $approvalStatus: String
    $documentMessage: [String]
  ) {
    approve_endorsement(
      offer_id: $offerId
      offer_endorsement_id: $offerEndorsementId
      approval_status: $approvalStatus
      document_message: $documentMessage
    )
  }
`;

export const deleteEndorsementOffer = gql`
  mutation DeleteKEKEndorsementOffer(
    $offerEndorsementDetailId: ID
    $offerEndorsementId: ID
  ) {
    deleteEndorsementOffer(
      offer_endorsement_detail_id: $offerEndorsementDetailId
      offer_endorsement_id: $offerEndorsementId
    )
  }
`;

export const unplaceOffer = gql`
  mutation UnplaceOfferPlaced($offerId: ID) {
    unplaceOfferPlaced(offer_id: $offerId)
  }
`;

export const sendHoldCover = gql`
  mutation SendHoldCover($offerId: ID) {
    sendHoldCover(offer_id: $offerId)
  }
`;

export const approveOffer = gql`
  mutation SetApprovalStatus(
    $offer_id: ID
    $status: String
    $messages: [String]
    $sendApprovalDocs: Boolean
  ) {
    setApprovalStatus(
      offer_id: $offer_id
      approval_status: $status
      document_message: $messages
      sendApprovalDocs: $sendApprovalDocs
    )
  }
`;
export const setTreatyApprovalStatus = gql`
  mutation ApproveTreaty(
    $treaty_id: ID
    $approval_status: String
    $document_message: [String]
    $approval_date: Date
  ) {
    setTreatyApprovalStatus(
      treaty_id: $treaty_id
      approval_status: $approval_status
      document_message: $document_message
      approval_date: $approval_date
    )
  }
`;
export const createKEKClassOfBusiness = gql`
  mutation CreateKEKClassOfBusiness(
    $businessName: String!
    $businessDetails: String!
  ) {
    createClassOfBusiness(
      business_name: $businessName
      business_details: $businessDetails
    ) {
      class_of_business_id
    }
  }
`;
export const updateKEKSingleClassOfBusiness = gql`
  mutation UpdateKEKSingleClassOfBusiness(
    $classOfBusinessId: ID!
    $businessName: String!
    $businessDetails: String!
  ) {
    updateSingleClassOfBusiness(
      class_of_business_id: $classOfBusinessId
      business_name: $businessName
      business_details: $businessDetails
    ) {
      class_of_business_id
    }
  }
`;

export const createKEKEndorsement = gql`
  mutation CreateKEKEndorsementOffer($offerInput: Offer_data!, $offerId: ID) {
    createEndorsementOffer(offer_input: $offerInput, offer_id: $offerId)
  }
`;

export const reinstateFacOffer = gql`
  mutation ReinstateFacOffer($offerId: ID) {
    reinstateFacOffer(offer_id: $offerId)
  }
`;

export const generateKEKProductionReport = gql`
  mutation GenerateProductionReport($reportData: ProductionReportData) {
    generateProductionReport(reportData: $reportData)
  }
`;
